import ButtonCopy from './buttonCopy';

export * from './buttonCopy';

export default ButtonCopy;
